import { combineReducers } from "redux";
import CalendarDaySelectedReducer from "./CalendarDaySelectedReducer";
import CalendarEventListReducer from "./CalendarEventListReducer";
import Cart_Data_reducer from "./Cart_Data_reducer";
import Cart_Icon_reducer from "./Cart_Icon_reducer";
import Exam_Data_reducer from "./Exam_Data_reducer";
import Exam_filter_reducer from "./Exam_filter_reducer";
import MNavChange from "./MNavChange";
import M_Nav_reducer from "./M_Nav_reducer";
import Open_nav_reducer from "./Open_nav_reducer";
import Product_filter_reducer from "./Product_filter_reducer";
import ShowDashNav from "./ShowDashNav";
export { default as chat } from "./chat.js";
export { default as message } from "./message.js";
export { default as publicApi } from "./public.js";
export { default as user } from "./user.js";
export { default as qr } from "./qr.js";
export { default as book } from "./book.js";
export { default as userProduct } from "./userProduct.js";
export { default as userFactor } from "./userFactor.js";
export { default as transport } from "./transport.js";
export { default as comment } from "./comment.js";
export { default as activation } from "./activation.js";
export { default as file } from "./file.js";

const Reducers = combineReducers({
  openNav: Open_nav_reducer,
  productFilter: Product_filter_reducer,
  MNav: M_Nav_reducer,
  ExamFilter: Exam_filter_reducer,
  ExamData: Exam_Data_reducer,
  CartData: Cart_Data_reducer,
  CartIcon: Cart_Icon_reducer,
  CalendarSelectedDay: CalendarDaySelectedReducer,
  CalendarEventList: CalendarEventListReducer,
  ShowDashNav: ShowDashNav,
  MNavDataType:MNavChange
});

export default Reducers;
